import { useMediaQuery } from '@crehana/react-hooks';
export var useBreakpoint = function useBreakpoint() {
  var _useMediaQuery = useMediaQuery({
      only: 'xs'
    }),
    isXs = _useMediaQuery.matches;
  var _useMediaQuery2 = useMediaQuery({
      only: 'sm'
    }),
    isSm = _useMediaQuery2.matches;
  var _useMediaQuery3 = useMediaQuery({
      only: 'md'
    }),
    isMd = _useMediaQuery3.matches;
  var _useMediaQuery4 = useMediaQuery({
      only: 'lg'
    }),
    isLg = _useMediaQuery4.matches;
  var currentBreakpoint = 'xs';
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (isLg) currentBreakpoint = 'lg';
  // biome-ignore lint/style/useBlockStatements: single-line early return
  else if (isMd) currentBreakpoint = 'md';
  // biome-ignore lint/style/useBlockStatements: single-line early return
  else if (isSm) currentBreakpoint = 'sm';
  return {
    isXs: isXs,
    isSm: isSm,
    isMd: isMd,
    isLg: isLg,
    currentBreakpoint: currentBreakpoint
  };
};